import {IPaginationState} from 'plugins/modules/pagination/types';
import {PayloadAction} from '@reduxjs/toolkit';

export function createPaginationActions<T extends IPaginationState>() {
    return {
        actionSetPage(state: T, {payload}: PayloadAction<T['page']>) {
            state.page = payload;
        },

        actionSetPageCount(state: T, {payload}: PayloadAction<T['count']>) {
            state.count = payload;
        },

        actionSetPageSize(state: T, {payload}: PayloadAction<T['size']>) {
            state.size = payload;
        },

        actionSetPaginationType(state: T, {payload}: PayloadAction<T['type']>) {
            state.type = payload;
        },
    };
}
